// Finnish

const lang = {
  gateMediaPreviewHeader: 'Saatat pitää myös',
  loadmore: 'Näytä lisää',
  nextMedia: 'Seuraava media',
  previousMedia: 'Edellnen media',
  closePost: 'Sulje julkaisu',
  nextPost: 'Seuraava julkaisu',
  previousPost: 'Edellinen julkaisu',
  outOfStock: 'Loppu varastosta',
  numberOfReviews(n) {
    return n === 1 ? 'arvostelu' : 'arvostelua'
  },
  reportFormField: 'Syötä viesti',
  reportPost: 'Ilmianna julkaisu',
  reportFormTitle: 'Haluatko tehdä ilmoituksen tästä kuvasta?',
  reportFormDetails:
    'Jos tämä kuva on mielestäsi sopimaton, laiton tai loukkaa jonkun oikeuksia, voit tehdä ilmoituksen sisällöstä. Jos teet ilmoituksen kuvasta/tekstistä, moderaattorit saavat tiedon asiasta ja ryhtyvät tarvittaviin toimenpiteisiin.',
  reportFormMessagePlaceholder: 'Ilmoita syy raporttiisi',
  reportFormMessageLabel: 'Viesti',
  reportFormEmailLabel: 'Sähköpostiosoitteesi',
  reportFormSubmitButtonText: 'Lähetä ilmoitus',
  reportFormCancelButtonText: 'Peruuta',
  reportFormSentTitle: 'Kiitos ilmoituksestasi!',
  reportFormSentCloseButtonText: 'Sulje',
  cardAndTileAriaLabel: 'Alla on luettelo sosiaalisen median tileillä julkaistuista julkaisuista',
  carouselAriaLabel: 'Alla on karuselli sosiaalisen median tileillä julkaistuista julkaisuista',
  singleAriaLabel: 'Alla on postaus sosiaalisen median tililtä',
  poweredBy: 'Perustuu Flowboxiin',
  postAltText: (userName, date) => {
    const publishedString = date ? ` published at ${date}` : ''
    const createdByString = userName ? ` by ${userName}` : ''
    return `Photo${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Lataa mediasi',
  openTheGate: 'Avaa valintaikkuna',
}

export default lang
